// extracted by mini-css-extract-plugin
module.exports = {"container":"CircleCheckbox_container__3OkLA","checkbox":"CircleCheckbox_checkbox__9Zt4z","icon":"CircleCheckbox_icon__1Fyyq"};